var map = {
	"./auto/Shop.vue": [
		37748,
		113,
		295,
		731,
		219,
		514,
		873
	],
	"./main/Shop.vue": [
		17816,
		113,
		295,
		731,
		219,
		64
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 49426;
module.exports = webpackAsyncContext;